<div class="error-banner">
  {{ error }}
  <button mat-flat-button class="reload" (click)="reloadPage()">
    {{ 'shared.reload' | transloco }}
  </button>
</div>
